import { Language as LanguageIcon } from '@mui/icons-material';

const Language = (): JSX.Element => <LanguageIcon fontSize="inherit" />;

export default Language;
